import React from "react";
import "./Ongoing.css";

const Ongoing = () => {
  return (
    <div>
      <h1>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum, cum!
      </h1>
    </div>
  );
};

export default Ongoing;
